<template>
  <div class="shortlist-companies-checklist k-page padding-20 fullheight">
    <Row type="flex" justify="space-between">
      <i-col style="display: flex;align-items: center;">
        <div class="icon-con back-icon" style="margin-right:10px">
          <img src="~@/assets/icons/back.svg" alt="back icon" width="40px" class="clickable" @click="handleGoBack">
        </div>
        <span style="font-size:18px">Tech Providers found : <b>{{ totalResults }}</b></span>
      </i-col>
      <i-col class="text-right">
        <span style="color:#b00101">Step 3/5</span>
        &nbsp; &nbsp;
        <span>Shortlist max. 20 <br/> and submit MyRFP form.</span>
      </i-col>
    </Row>
    <Row :gutter="20" class="padding-bt-20 companies-selected-list">
      <i-col :xs="24" :sm="18" class="companies-listing">
        <div class="shortlist-companies">
          <CompaniesList ref="CompaniesList" class="companies-list" @total="handleTotalResults" :enableSelection="true" @selected="handleSelectedCompanies" :showCount="false"/>
        </div>
      </i-col>
      <i-col :xs="24" :sm="6">
        <Card>
          <Button class="k-btn-1" @click="handleSubmitRFP" size="large" long :loading="isLoading" :disabled="!selectedCompanies.length > 0">Confirm my Shortlist</Button>
          <p class="text-center padding-t-20">Shortlisted : <b>{{ countSelectedCompanies }}</b></p>
          <div class="shortlisted-companies padding-t-20">
            <p v-for="(com, idx) in selectedCompanies" :key="idx">
              {{ com.name }}
            </p>
          </div>
        </Card>
      </i-col>
    </Row>
    <ShortlistSelection ref="ShortlistSelection" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CompaniesList from '@/components/companies/CompanyCardList'
import ShortlistSelection from '@/components/companies/ShortListSelection'

export default {
  components: {
    CompaniesList,
    ShortlistSelection
  },

  data () {
    return {
      totalResults: null,
      isLoading: false,
      selectedCompanies: []
    }
  },

  mounted () {
    if (!this.getTechProvidersFilters) {
      this.$router.push({
        name: 'companies'
      })
    }
  },

  computed: {
    ...mapGetters(
      {
        getTechProvidersFilters: 'techProviders/getTechProvidersFilters'
      }
    ),
    countSelectedCompanies () {
      return this.selectedCompanies.length
    }
  },

  methods: {
    ...mapActions(
      {
        setRfpShortList: 'rfps/setRfpShortList'
      }
    ),

    handleTotalResults (val) {
      this.totalResults = val
    },

    handleGoBack () {
      this.$router.go(-1)
    },

    handleSelectedCompanies (data) {
      this.selectedCompanies = data
    },

    handleSubmitRFP () {
      this.setRfpShortList(this.selectedCompanies.map(a => a.id))
      this.$refs.ShortlistSelection.openModal()
    }
  }
}
</script>

<style lang="scss" scoped>
.shortlist-companies-checklist {
  .companies-selected-list {
    height: calc(100% - 60px);
    .companies-listing {
      height: 100%;
      overflow: auto;
      overflow-y: scroll;
      overflow-x: hidden;
    }
    .shortlisted-companies {
      p {
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0px;
        }
      }
    }
  }
}
</style>
